// Rollout stages: "disabled" | "internal" | "full"
// Drives visibility of Contact Management + AAL tabs and all new behaviour.
const ROLLOUT_STAGE = (process.env.REACT_APP_AAL_CONTACT_ROLLOUT || 'disabled').toLowerCase();

export function getRolloutStage() {
  return ROLLOUT_STAGE;
}

export function isFeaturesEnabled(userType) {
  if (ROLLOUT_STAGE === 'full') return true;
  if (ROLLOUT_STAGE === 'internal' && userType === 'internal') return true;
  return false;
}

export function isTabVisible(tabType, userType) {
  if (tabType !== 'aal' && tabType !== 'contact') return true;
  return isFeaturesEnabled(userType);
}

// Default tab config — can be overridden by API response in future
const DEFAULT_TAB_CONFIG = {
  contact_management: { contact_details: true, inductions: true, access_lists: true, moj: false },
  customer_profiles: { contact_details: true, moj: true, inductions: true, access_lists: true },
};

let _tabConfig = DEFAULT_TAB_CONFIG;

export function setTabConfig(config) {
  if (config) _tabConfig = config;
}

export function getTabConfig() {
  return _tabConfig;
}
